module.exports = __webpack_public_path__ + "static/media/contrato.214cb2c0.svg";